import React from 'react';
import Interactions from './Interactions';

const App = () => <Interactions query_url='https://cms.aimogen.com/_/items/interactions?sort=-asked_on&limit=20&fields=*.*&filter[emotion_transcript][empty]' videochat={false}/>;

export default App;
